import * as BABYLON from "babylonjs";
import config from "../config";
export class Pingtai {
  constructor(objinfo) {
   if(objinfo.meta.meshType=='水泥台'){
    this.init(objinfo)
   }else{
    this.initground(objinfo)
   }
  }
  hide(p){
    this.mesh.visibility = p.visibility;
  }
  init(objinfo){
    let width = objinfo.meta.width;
    let height = config.table.height;
    let depth = objinfo.meta.depth;
    this.mesh = BABYLON.MeshBuilder.CreateBox(objinfo.meta.id, {
      width,
      height,
      depth
    });
    this.mesh.material = levelsShowIns.pingtaiMat.clone();
    this.mesh.material.albedoTexture.uScale = depth/5;
    this.mesh.material.albedoTexture.vScale = width/5;
    this.mesh.position.x = objinfo.meta.x
    this.mesh.position.z = -objinfo.meta.z
    this.mesh.position.y = config.table.height / 2 
    this.mesh.receiveShadows = true;
    levelsShowIns.eventbus.$on('meshhide', this.hide, this);
  }
  initground(objinfo){
    let width = 1;
    let height = 1;
    let depth = 1;
    this.mesh = BABYLON.MeshBuilder.CreateBox(objinfo.meta.id, {
      width,
      height,
      depth
    });
    this.mesh.visibility = 0.0
  }
  destroy() {
    this.mesh.dispose();
    levelsShowIns.eventbus.$off('meshhide');
    // 长时间点击会有 没有销毁的状况
  }
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Object/Pingtai.js